import { useSelector } from 'react-redux';

import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import { quantitySelector } from '@/productDiscovery/ProductPage/common/modules/QuantitySelector/Quantity.ducks';

export const useQuantity = (): number =>
  useSelector<SpartacuxProductDiscoveryDomainState, number>(quantitySelector);
